import React from 'react';
import { motion } from 'framer-motion';
export function Transformation() {
  return <section className="py-24 px-4 bg-dark-900 relative overflow-hidden" data-id="element-167">
      <div className="absolute inset-0 bg-amber-500/5 blur-[100px] pointer-events-none" data-id="element-168" />

      <div className="max-w-4xl mx-auto relative z-10 text-center" data-id="element-169">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-3xl md:text-4xl font-bold text-white mb-8" data-id="element-170">
          Lo que cambia cuando empiezas a usarlo
        </motion.h2>

        <motion.p initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.2
      }} className="text-xl text-gray-400 mb-12" data-id="element-171">
          No es que de repente te vuelves "valiente". Es algo más práctico:
        </motion.p>

        <div className="grid gap-6 text-left" data-id="element-172">
          {['El miedo sigue apareciendo… pero ya no manda.', 'Tu día deja de depender de tu estado de ánimo.', 'Recuperas la identidad que el miedo te robó: la persona que inicia.'].map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.3 + index * 0.1
        }} className="bg-dark-800 p-6 rounded-lg border-l-4 border-amber-500 shadow-lg" data-id="element-173">
              <p className="text-lg md:text-xl text-white font-medium" data-id="element-174">
                {item}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}